import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FourOFour from "../containers/FourOFour";
import logo from "../branding/current/logo.png";
import logoDark from "../branding/current/logo_dark.png";
import "./NoNavLayout.css";
import { inIframe } from "../misc/inIframe";

class NoNav extends React.Component {
  render() {
    if (
      this.props.kiosk ||
      (!this.props.inIframe && inIframe()) ||
      (this.props.forceIframe && !inIframe())
    ) {
      return <FourOFour />;
    }

    return (
      <div>
        <header className="branding-header-login" role="banner">
          <a
            href={this.props.text("login.logo.href")}
            className="branding-header-login-link"
          >
            <div className="nonav-focus-border">
              <img
                className="noNav-img"
                src={this.props.contrast ? logoDark : logo}
                alt={this.props.text("menu.logo")}
              />
            </div>
          </a>
        </header>
        <div className="main-container">
          <div className="row">
            <div
              className={
                this.props.location.pathname === "/registration" &&
                this.props.text("registration.info") !== " "
                  ? "col-md-0 col-lg-1 col-xl-1"
                  : "col-md-2 col-lg-3 col-xl-3"
              }
            ></div>
            <div
              className={
                this.props.location.pathname === "/registration" &&
                this.props.text("registration.info") !== " "
                  ? "col-md-12 col-lg-10 col-xl-10"
                  : "col-md-8 col-lg-6 col-xl-6"
              }
            >
              <div className="margin-login-box"></div>
              {this.props.children}
            </div>
            <div
              className={
                this.props.location.pathname === "/registration" &&
                this.props.text("registration.info") !== " "
                  ? "col-md-0 col-lg-1 col-xl-1"
                  : "col-md-2 col-lg-3 col-xl-3"
              }
            ></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    text: state.config.text,
    contrast: state.accessibility.isHighContrast,
    kiosk: state.config.mode.kiosk,
    inIframe: state.config.mode.inIframe,
    forceIframe: state.config.mode.forceIframe,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NoNav));






// WEBPACK FOOTER //
// ./src/layouts/NoNavLayout.js